/**
 * Chat utilities - shared helpers for chat components
 */

/**
 * Determine if a channel is private.
 * Handles snake_case, camelCase, type, and string values from API.
 */
export function isChannelPrivate(channel: any): boolean {
  if (!channel) return false;
  const type = channel.type;
  const isPrivate = channel.is_private ?? channel.isPrivate;
  return (
    type === 'private' ||
    isPrivate === true ||
    isPrivate === 'true' ||
    isPrivate === 't'
  );
}
